"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.defaultFeatureFlagsWithOverrides = exports.FeatureFlagsContext = exports.defaultFeatureFlags = exports.FeatureFlagsProvider = exports.useFeatureFlags = void 0;
const tslib_1 = require("tslib");
const react_1 = tslib_1.__importDefault(require("react"));
function useFeatureFlags() {
    return react_1.default.useContext(exports.FeatureFlagsContext);
}
exports.useFeatureFlags = useFeatureFlags;
function FeatureFlagsProvider(props) {
    return (react_1.default.createElement(exports.FeatureFlagsContext.Provider, { value: props.value }, props.children));
}
exports.FeatureFlagsProvider = FeatureFlagsProvider;
exports.defaultFeatureFlags = {
    metricsDataCatalogEnabled: true,
    writableFieldDescriptionsEnabled: true,
    fieldDescriptionInheritanceLineageEnabled: true,
    publishedConnectionsLineageEnabled: true,
    databasesInProjectsEnabled: true,
    lensLineageEnabled: true,
    relevantAssetsEnabled: false,
    mixedContentConnectToDialogEnabled: false,
    searchAndFilterOnLineagePageEnabled: true,
    dataCloudInCatalogMVPEnabled: true,
    customLabelCategoriesEnabled: true,
    suggestDescriptionsEnabled: true,
    unifiedLabelsDialogEnabled: true,
    pulseInDataCatalogEnabled: false,
};
exports.FeatureFlagsContext = react_1.default.createContext(exports.defaultFeatureFlags);
function defaultFeatureFlagsWithOverrides(overrides) {
    return Object.assign(Object.assign({}, exports.defaultFeatureFlags), overrides);
}
exports.defaultFeatureFlagsWithOverrides = defaultFeatureFlagsWithOverrides;
//# sourceMappingURL=FeatureFlagsContext.js.map